import React from 'react';
import PropTypes from 'prop-types';
// Core components
import Skeleton from 'components/core/Skeleton';
import TableRow from 'components/core/table/TableRow';
import TableCell from 'components/core/table/TableCell';

const ListTemplateRowLoading = React.memo(({ loading, columnsQuantity }) => (
  <TableRow hidden={!loading}>
    <TableCell colSpan={columnsQuantity}>
      <Skeleton />
    </TableCell>
  </TableRow>
));

ListTemplateRowLoading.displayName = 'ListTemplateRowLoading';

ListTemplateRowLoading.propTypes = {
  loading: PropTypes.bool.isRequired,
  columnsQuantity: PropTypes.number.isRequired,
};

export default ListTemplateRowLoading;



// WEBPACK FOOTER //
// ./components/templates/ListTemplateRowLoading.js